import { FC } from 'react'
import { Form, FormType } from './form/Form'

export const Template: FC & FormType = (): JSX.Element => <></>

Template.Form = Form
